<template>
    <div class="login-contain">
        <div class="login-content">
            <div class="login_img">
                <img src="../assets/picture.png" />
            </div>
            <div class="login_form">
                <div class="form_div">
                    <h2>Log In You Account</h2>
                    <div>
                        <label class="form_label">Account</label>
                        <el-input v-model="account"
                                  size="medium"
                                  style="width: 300px;"></el-input>
                    </div>
                    <div>
                        <label class="form_label">Password</label>
                        <el-input v-model="password"
                                  type="password"
                                  size="medium"
                                  style="width: 300px;"></el-input>
                    </div>
                    <div v-show="isShowValid"
                         class="valid_tips">{{tips}}</div>
                </div>
                <div class="login_btn"
                     @click="submit">
                    <a>LOG IN</a>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
import api from '@api/cooperation'
import Cookies from 'js-cookie'
import ElFormItem from "../../node_modules/element-ui/packages/form/src/form-item.vue";
export default {
    components: { ElFormItem },
    data () {
        return {
            account: '',
            password: '',
            isShowValid: false,
            tips: ''
        }
    },
    mounted: function () {

    },
    methods: {
        validateParameter () {
            if (!this.account || !this.password) {
                this.isShowValid = true;
                this.tips = 'Please enter Account or Password';
                return false;
            }
            this.isShowValid = false;
            return true;
        },
        submit () {
            if (this.validateParameter()) {
                api.login({
                    account: this.account,
                    password: this.password
                }).then((res) => {
                    if (res.success) {
                        if (res.data) {
                            Cookies.set('account', res.data.account)
                            Cookies.set('admin_token', res.data.token)
                            this.$router.replace('/joinList');
                        }
                    } else {
                        this.isShowValid = true;
                        this.tips = res.error.message;
                    }
                }).catch((error) => {
                    this.$showErrorMessage('Service Exceptions！')
                })
            };
        }
    }
}
</script>
<style scoped>
.login-contain {
    background-color: #e2f3fd;
    height: 100%;
}
.login-content {
    width: 800px;
    position: fixed;
    left: 50%;
    top: 50%;
    -webkit-transform: translateX(-50%) translateY(-50%);
    -moz-transform: translateX(-50%) translateY(-50%);
    -ms-transform: translateX(-50%) translateY(-50%);
    transform: translateX(-50%) translateY(-50%);
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
}
.login_form {
    flex: 1;
    background-color: #fff;
    padding: 50px 50px 80px 50px;
    margin-left: 20px;
}
.form_div {
    width: 300px;
    margin-bottom: 30px;
}
.login_img img {
    width: 500px;
}
.form_div h2 {
    margin-bottom: 30px;
}
.form_div > div {
    margin-bottom: 10px;
}
.form_div .form_label {
    display: block;
    text-align: left;
    font-size: 14px;
    font-weight: 600;
    line-height: 30px;
}
.login_btn {
    display: block;
    width: 300px;
    height: 45px;
    line-height: 45px;
    background-image: linear-gradient(-90deg, #feb058 0%, #fe7b54 100%);
    border-radius: 4px;
    text-align: center;
}
.login_btn a {
    color: #fff;
    cursor: pointer;
}
.valid_tips {
    color: #f1453d;
    font-size: 12px;
    text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue